import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Icon,
  LinkWrapper,
} from 'athenaeum';

import styles from './logo.module.scss';

const Logo = ({ className }) => (
  <LinkWrapper
    className={cx(className, styles['logo-wrapper'])}
    href="/"
  >
    <Icon
      width="100%"
      height="100%"
      icon="pgLogoBlack"
      className={styles.logo}
    />
  </LinkWrapper>
);

Logo.propTypes = {
  className: PropTypes.string
};

export default Logo;



// WEBPACK FOOTER //
// ../src/templates/MainNav/Logo/index.js